import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { Icon } from 'react-frontier';
import { Request } from '../SiteClasses';
import API from '../API';
import moment from 'moment';

var SearchRequestModal = (props: SearchCoreProps<Request>)=>{
	return <SearchCoreModal
		title='Buscar solicitud'
		searchPlaceholder='Buscar por ID o creador...'
		size='small'
		{...props}
		searchData={(query, page, pageSize)=>{
			return API.getRequests(page * pageSize, pageSize, query, [1], true);
		}}
		onShowLoad={(query, page, pageSize)=>{
			return API.getRequests(page * pageSize, pageSize, query, [1], true);
		}}
		pageSize={8}
		table={[
			{ name: 'ID', key: 'request_id', collapsing: true },
			{ name: 'Retorno', key: 'date_return', collapsing: true, render: (val: number)=> val ? moment.unix(val).format('DD/MM/YY') : <Icon name='minus' /> },
			{ name: 'Comentarios', key: 'description', render: (val: any)=> val || <Icon name='minus' /> },
			{ name: 'Creador', key: 'user_creator_name', collapsing: true, render: (val: any)=> val || <Icon name='minus' /> },
		]}
	/>;
};

export default SearchRequestModal;
